import { graphql } from '@/utils/graphql';

export const matchdayCardDateFragment = graphql(`
  fragment matchdayCardDateFields on matchdays {
    start_datetime
    postponed
  }
`);
